import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    Dropdown, MenuItem
} from 'react-bootstrap';

const PaymentAffectationActionButton = ({
  payment,
  deletePayment,
  reQualifyPayment
}) => {

  //console.log("------>>", payment, deletePayment);

  return(
    <Dropdown pullRight  id="payment-validation-dropdown" className="dropdown-action-btn">
      <Dropdown.Toggle className="btn-wd btn-icon">
        <i className="fa fa-lg fa-check"></i>
        Action 
      </Dropdown.Toggle>
      <Dropdown.Menu className="action-dropdown-menu">
        {/*availableActions.includes("DELETE") ?*/
          <MenuItem onClick={() => deletePayment(payment.id)} eventKey="5">
            <i className="fa fa-lg fa-trash"></i>
            <FormattedMessage id='ids_delete'/>
          </MenuItem> /*: <div/>*/}     
          <MenuItem onClick={() => reQualifyPayment(payment.id)} eventKey="9">
            <i className="fa fa-lg fa-refresh"></i>
            <FormattedMessage id='ids_qualifAuto' description="Qualifier auto"
              defaultMessage="Qualifier auto"/>
          </MenuItem>        
      </Dropdown.Menu>
    </Dropdown>
  );
}

export default PaymentAffectationActionButton;
